<script setup lang="ts">
import { inject, Ref } from 'vue';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const onConfirm = dialogRef.value.options.emits.onConfirm;
const onClose = dialogRef.value.options.emits.onClose;
</script>
<template>
  <div class="add_confirm_modal">
    <div class="modal-mask">
      <div class="modal-container text-center flex flex-column justify-content-between">
        <div class="dialog_message mb-2">
          <div class="font-bold mb-2 text-lg">{{ $t('common.have_to_select_to_add_flight') }}</div>
          <div class="mb-2">{{ $t('common.proceed_without_flight_quote') }}</div>
        </div>
        <div class="flex justify-content-end">
          <Button class="mr-3 w-2 flex justify-content-center" id="btn_yes" @click="onConfirm()">{{ $t('common.yes') }}</Button>
          <Button class="w-2 flex justify-content-center" id="btn_no" @click="onClose()">{{ $t('common.no') }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>
